import { defineI18nConfig } from '#i18n'
import enUS from './locales/en-US.json'
import esMX from './locales/es-MX.json'
import frFR from './locales/fr-FR.json'
import deDE from './locales/de-DE.json'

export default defineI18nConfig(() => ({
    legacy: false,
    // Keep locale registration in one place while loading message bodies from JSON files.
    messages: {
        'en-US': enUS,
        'es-MX': esMX,
        'fr-FR': frFR,
        'de-DE': deDE
    },
    fallbackLocale: 'en-US'
}))
